import { Box, type BoxProps } from '@mui/material';

interface PmCardProps extends Omit<BoxProps, 'children'> {
  /** Hebt die Karte mit Petrol-Border hervor (Clickdummy `.card.hl`). */
  highlight?: boolean;
  /** Innerer Padding-Reset — z. B. wenn die Karte selbst eine Tabelle rendert. */
  flush?: boolean;
  children: React.ReactNode;
}

/** PM-Card: dunklerer Hintergrund als die Page, abgerundet, dezenter Schatten. */
export function PmCard({ highlight, flush, sx, children, ...rest }: PmCardProps) {
  return (
    <Box
      {...rest}
      sx={[
        {
          background: 'var(--pm-bg-subtle)',
          color: 'var(--pm-fg-base)',
          border: '1px solid var(--pm-bg-deep)',
          borderRadius: 'var(--pm-radius)',
          boxShadow: 'var(--pm-shadow)',
          padding: flush ? 0 : 2.25,
          ...(highlight && { borderLeft: '3px solid var(--rittec-petrol)' }),
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {children}
    </Box>
  );
}
